package org.matthewo.schema.games

import org.matthewo.math.div
import org.matthewo.math.minus
import org.matthewo.math.plus
import org.matthewo.math.times
import org.matthewo.schema.CRI_YEAR_PREFIX
import org.matthewo.schema.RankingMetrics
import org.matthewo.schema.StandardMetrics
import org.matthewo.symbolprocessor.GameSchema
import org.matthewo.symbolprocessor.Metric
import org.matthewo.symbolprocessor.Period

@GameSchema(CRI_YEAR_PREFIX + 2023, "Center Stage CRI", 3)
interface MetricsCenterStageCRI<T : Number> : StandardMetrics<T>, RankingMetrics<T> {
    override val tbp1
        get() = apPurple + apYellow + apNavigation +
                apBackstage * 3 / 4 +
                (apBackdrop + apSharedBackdrop) * 5 / 8 +
                (apMosaic + apSharedMosaic + apSet + apSharedSet) / 2

    @Metric(Period.AUTO, "Purple")
    val apPurple: T
    @Metric(Period.AUTO, "Yellow")
    val apYellow: T
    @Metric(Period.AUTO, "Navigation")
    val apNavigation: T
    @Metric(Period.AUTO, "Backstage")
    val apBackstage: T
    @Metric(Period.AUTO, "Backdrop")
    val apBackdrop: T
    @Metric(Period.AUTO, "Mosaic")
    val apMosaic: T
    @Metric(Period.AUTO, "Set")
    val apSet: T
    @Metric(Period.AUTO, "Shared Backdrop")
    val apSharedBackdrop: T
    @Metric(Period.AUTO, "Shared Mosaic")
    val apSharedMosaic: T
    @Metric(Period.AUTO, "Shared Set")
    val apSharedSet: T

    @Metric(Period.TELEOP, "Backstage")
    val tpBackstage: T
    @Metric(Period.TELEOP, "Backdrop")
    val tpBackdrop: T
    @Metric(Period.TELEOP, "Mosaic")
    val tpMosaic: T
    @Metric(Period.TELEOP, "Set")
    val tpSet: T
    @Metric(Period.TELEOP, "Shared Backdrop")
    val tpSharedBackdrop: T
    @Metric(Period.TELEOP, "Shared Mosaic")
    val tpSharedMosaic: T
    @Metric(Period.TELEOP, "Shared Set")
    val tpSharedSet: T

    @Metric(Period.ENDGAME, "Drone")
    val epDrone: T
    @Metric(Period.ENDGAME, "Hang")
    val epHang: T
    @Metric(Period.ENDGAME, "Park")
    val epPark: T

    @Metric(Period.ALL, "Collage")
    val rpCollage: T
    @Metric(Period.ALL, "Mural")
    val rpMural: T
    @Metric(Period.ALL, "Finale")
    val rpFinale: T
}

fun <T : Number> MutableMetricsCenterStageCRI<T>.computeTotals() {
    auto = apPurple + apYellow + apNavigation + apBackstage + apBackdrop + apMosaic + apSet + apSharedBackdrop + apSharedMosaic + apSharedSet
    teleop = tpBackstage + tpBackdrop + tpMosaic + tpSet + tpSharedBackdrop + tpSharedMosaic + tpSharedSet
    endgame = epDrone + epHang + epPark
    npTotal = auto + teleop + endgame
    total = npTotal - penalty
}
